import state from './knowledgeBaseState'
import actions from './knowledgeBaseActions'
import getters from './knowledgeBaseGetters'
import mutations from './knowledgeBaseMutations'

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
